import { render, staticRenderFns } from "./indexPkList.vue?vue&type=template&id=945e54bc&scoped=true&"
import script from "./indexPkList.vue?vue&type=script&lang=js&"
export * from "./indexPkList.vue?vue&type=script&lang=js&"
import style0 from "./indexPkList.vue?vue&type=style&index=0&id=945e54bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945e54bc",
  null
  
)

export default component.exports